<template>
  <tr
    :class="{ extra: extra, pointer: hasSelectedBlock }"
    class="listener--show"
    @click="onToggleBlock"
  >
    <td>
      <span v-if="hasSelectedBlock" class="work-arrow">
        <v-icon size="16" :class="{ 'work-arrow--open': isBlockOpened }">mdi-chevron-down</v-icon>
      </span>
      {{ item.work_type.name }}
    </td>
    <td>
      {{ $formatDate(item.start_date) + ' - ' + $formatDate(item.end_date) }}
    </td>
    <td>
      {{
        item.work_type.is_hourly === 0
          ? $roundNumberToTenths(item.employee_done) + ' ' + item.work_type.measure
          : $formatTime($roundNumberToTenths(item.employee_done))
      }}
    </td>
  </tr>
</template>

<script>
// import EmployeesPhoto from 'components/employees/EmployeesPhoto'

export default {
  name: 'TimeControlShowGridEmployeeItem',
  // components: { EmployeesPhoto },
  props: {
    item: Object,
    tableHead: Array,
    extra: Boolean,
    min: Boolean,
    isBlockOpened: Boolean,
  },
  computed: {
    hasSelectedBlock() {
      return !!(this.item && Array.isArray(this.item.selected_blocks) && this.item.selected_blocks.length)
    },
  },
  methods: {
    onToggleBlock() {
      if (!this.hasSelectedBlock) return
      this.$emit('toggle-block')
    },
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
  },
}
</script>

<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}

.work-arrow {
  display: inline-flex;
  margin-right: 6px;

  :deep(.v-icon) {
    transition: transform 0.2s ease;
  }

  &--open {
    transform: rotate(180deg);
  }
}
</style>
